import { getVueTemplate } from "../../_imports/utils/utils.common";
import FormsBaseInputField from "./_imports/forms-base-input-field.vue";

export default {
    name: 'forms-url-field',
    template: getVueTemplate('forms-url-field'),
    mixins: [
        FormsBaseInputField
    ],
    data() {
        return {
            doneTypingTimeout: 500,
        };
    },
    created() {
        this.addValidations();
    },
    methods: {
        addValidations() {
            this.addFieldValidation(validation => {
                if (!/^(http|https):\/\/[^ "]+\.[^ "]+$/.test(this.userInput)) {
                    return validation.hasFailed(this.getFieldErrorMessage('invalidUrlError'));
                }

                return validation.hasPassed();
            });
        }
    }
};